(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const collectionList = document.querySelector('results-list');
  if (collectionList) {
    collectionList.addEventListener('click', (e) => {
      if (e.target.closest('.product-grid__item')) {
        const nav = document.querySelector('nav.breadcrumbs');
        if (!nav) return;
        const crumbs = Array.from(nav.querySelectorAll('.breadcrumbs__link:not(.breadcrumbs__link--home)')).map(
          (a) => ({ url: a.getAttribute('href'), title: a.textContent.trim() })
        );
        sessionStorage.setItem('breadcrumb_collection', JSON.stringify(crumbs));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
